import { render, staticRenderFns } from "./MainHeadComponent.vue?vue&type=template&id=a1d6d614"
import script from "./MainHeadComponent.vue?vue&type=script&lang=js"
export * from "./MainHeadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports